import React, { useEffect } from "react";
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Divider,
    Stack,
    Grid,
    Avatar,
    Button,
    Paper,
    Chip,
    Skeleton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from '@mui/icons-material/Delete';
import axios from '../api/axiosConfig'
import { getInitials, stringToColor, stringToSoftColor } from "../utils/DataHelper";
import dayjs from "dayjs";
import { useState } from "react";

import PaymentResponse from "./PaymentResponse";
import { Print } from "@mui/icons-material";

export default function PaymentDetailModal({ open, onClose, data, title = "Record Detail" }) {

    const avatarColor = stringToColor(data?.nama);
    const avatarSoftColor = stringToSoftColor(data?.nama);
    const [payResponModalOpen, setPayResponModalOpen] = useState(false);

    const mPaycode = data?.paycode
    const [loading, setLoading] = useState(false)
    const [rows, setRows] = useState([])

    const fetchData = async () => {
        try {
            // console.log('Start Fetch Data')
            setLoading(true);

            const resp = await axios.get("/paydetail.php", {
                params: {
                    paycode: mPaycode,
                }
            })

            // console.log("Pay Detail", resp.data.details)
            setRows(resp.data.details); // API must return array of rows
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [mPaycode]);

    const sesuaikanDataKePrinter = (mdata) => {
        // var retVal = { 
        //     success: true, 
        //     paycode: mPaycode,
        //     details: {paid:mdata} }
        const transformed = {
            success:true,
            paycode:mPaycode,
            details: {
                paid: mdata?.map(item => ({
                    cardyear: item.year,
                    cardmonth: item.month_name,
                    cardcode: item.cardcode,
                    paycode: mPaycode,
                    amount: item.amount,
                })),
                failed: [],
            },
        };
        return transformed
    }

    const handleCancelPayment = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to cancel these payments?"
        );

        if (!confirmed) return;
        try {
            const cardcode = {
                cardcodes: rows.map(item => item.cardcode)
            };


            console.log('param', cardcode)
            const resp = await axios.post("/paybillingcancel.php", cardcode)
            console.log('Respon', resp)
            onClose()
        } catch (error) {

        }
    }


    return (
        <>
            <Modal open={open} onClose={onClose}>

                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "92vw", md: "72vw", lg: "60vw" },
                        maxHeight: "86vh",
                        bgcolor: "background.paper",
                        borderRadius: 4,
                        boxShadow: "0 24px 60px rgba(15,23,42,0.25)",
                        border: "1px solid",
                        borderColor: "divider",
                        p: { xs: 2, md: 3 },
                        overflow: "hidden",
                    }}
                >

                    {/* Header */}
                    <Stack direction="row" spacing={1.5} alignItems="center">
                        {/* Avatar */}
                        {data ? (
                            <>
                                <Avatar
                                    sx={{
                                        bgcolor: avatarColor,
                                        color: "#fff",
                                        fontWeight: 700,
                                        width: 42,
                                        height: 42,
                                        fontSize: 15,
                                    }}
                                >
                                    {getInitials(data.nama)}
                                </Avatar>

                                <Box flex={1}>
                                    <Typography variant="h5" fontWeight={800}>
                                        {data.nama}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {data.membercode} • {data.paycode}
                                    </Typography>
                                </Box>



                            </>
                        ) : null}

                        <IconButton
                            onClick={onClose}
                            sx={{ position: "absolute", top: 8, right: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <Divider sx={{ mt: 2 }} />

                    <Box sx={{ overflowY: "auto", maxHeight: "56vh", pr: 1, p: 2 }}>
                        {data ? (
                            <Box >
                                <Typography variant="subtitle1" fontWeight={700} mb={1}>
                                    Payment Detail
                                </Typography>
                                <Grid container spacing={1} mt={2}>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <HVText accentColor={avatarSoftColor} label="Nomor Anggota" value={data.membercode} />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <HVText accentColor={avatarSoftColor} label="Kode Bayar" value={data.paycode} />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <HVText accentColor={avatarSoftColor} label="Tanggal" value={dayjs(data.dtcreate).format("DD MMMM YYYY - hh:mm:ss")} />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <HVText accentColor={avatarSoftColor} label="Jumlah Pembayaran" value={data.amount} />
                                    </Grid>

                                </Grid>

                                <Box mt={2} flex={0}>
                                    <Typography variant="subtitle2" fontWeight={600}>
                                        Pembayaran untuk bulan
                                    </Typography>
                                    <Stack
                                        direction="row"
                                        mt={1}
                                        flexWrap="wrap"
                                        gap={1}
                                    >
                                        {loading ? (
                                            [...Array(6)].map((_, i) => (
                                                <Skeleton key={i} variant="rounded" width={110} height={44} />
                                            ))
                                        ) : (
                                            rows?.map((row) => {
                                                return (
                                                    <Paper key={row.id} elevation={0} sx={{
                                                        px: 2, py: 1.5,
                                                        border: `solid 1px ${avatarSoftColor}`,
                                                        borderRadius: 2,
                                                        background:
                                                            `linear-gradient(180deg, #ffffff 0%, ${avatarSoftColor} 100% )`,
                                                        "&:hover": {
                                                            backgroundColor: "action.hover",
                                                            transform: 'translateY(-1px)',
                                                            boxShadow: `0 6px 18px ${avatarSoftColor}`,
                                                        },
                                                    }}>
                                                        <Stack direction={'row'} spacing={1}>
                                                            <Typography variant="body">{row.year}</Typography>
                                                            <Typography variant="body" fontWeight={700}>{row.month_name}</Typography>
                                                        </Stack>
                                                    </Paper>
                                                )
                                            })
                                        )}
                                    </Stack>
                                </Box>
                            </Box>



                        ) : (
                            <Typography color="text.secondary" align="center">
                                No data available
                            </Typography>
                        )}
                    </Box>


                    <Divider sx={{ my: 2 }} />
                    <Stack sx={{ display: "flex", justifyContent: "flex-end" }}
                        direction={'row'}
                        spacing={1} >
                        <Button variant="contained" color={'error'}
                            onClick={handleCancelPayment} startIcon={<DeleteIcon fontSize="16" />}
                        >
                            Batalkan Pembayaran
                        </Button>
                        <Box flex={1} />
                        <Button
                            variant="contained"
                            onClick={() => { setPayResponModalOpen(true) }}
                            startIcon={<Print />}
                        > Print</Button>
                        <Button variant="outlined" onClick={onClose}  >
                            Tutup
                        </Button>
                    </Stack>
                </Box>


            </Modal>

            <PaymentResponse
                open={payResponModalOpen}
                onClose={() => setPayResponModalOpen(false)}
                data={sesuaikanDataKePrinter(rows)}
            />
        </>

    );
}

const HVText = ({
    label,
    value,
    accentColor = "#9e5bad",
    minHeight = 72,
}) => {
    const displayValue =
        value === null || value === undefined || value === ""
            ? "-"
            : value;

    return (
        <Box
            sx={{
                overflow: "hidden",
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                transition: "all .2s ease",
                "&:hover": {
                    bgcolor: "action.hover",
                    transform: "translateY(-1px)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                },
            }}
        >
            <Stack direction="row" alignItems="stretch">
                {/* Accent bar */}
                <Box
                    sx={{
                        width: 6,
                        bgcolor: accentColor,
                        minHeight,
                    }}
                />

                {/* Content */}
                <Box sx={{ px: 2, py: 1.2 }}>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 600 }}
                    >
                        {label}
                    </Typography>

                    <Typography
                        variant="body1"
                        color="text.primary"
                        sx={{ fontWeight: 500 }}
                    >
                        {displayValue}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
};
